import React, { useContext, useEffect, useState, useMemo } from 'react';
import { getJavamonImage } from '../../../../dao/jutge/GetJavamonConfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Button,
    FloatButton,
    Progress,
    Table,
    TableProps,
    Tag,
    Card,
    Space,
    Typography,
    Tooltip,
    Spin,
    Alert,
    Switch,
    Dropdown,
    Row,
    Col,
    Statistic,
    Input,
    Badge,
    DatePicker
} from "antd";
import { ColumnsType } from "antd/es/table";
import {
    BiArrowFromLeft,
    BiPlus,
    BiRefresh
} from "react-icons/bi";
import { FaBookOpen, FaCheck, FaEye, FaQuestionCircle } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { SlMagnifier } from "react-icons/sl";
import { VscSettingsGear } from "react-icons/vsc";
import { IoOptions } from "react-icons/io5";
import { MdCatchingPokemon } from "react-icons/md";


import { GetPractica } from "../../../../dao/jutge/GetPracticaId";
import { PutUsuariIdActivitatId } from "../../../../dao/PutUsuariIdActivitatId";
import { GetUsuariIdJutgeActivitatsId } from "../../../../dao/GetUsuariIdJutgeActivitatsId";
import { GetUsuariIdJutgeActivitats } from "../../../../dao/GetUsuariIdJutgeActivitats";
import RevisioModal from "./RevisioModal";
import NouModal from "./NouModal";
import TestsListModal from "./TestsListModal";
import JutgeColors from "../../../../styles/JutgeColors";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { IoIosCheckmark } from "react-icons/io";
import { PiExamLight } from "react-icons/pi";
import ExamenModal from "./ExamenModal";
import PremiosModal from "./PremiosModal";
import { CiCircleCheck } from "react-icons/ci";
import { GetJutgeActivitatIdProblemaIdCodi } from "../../../../dao/jutge/GetJutgeActivitatIdProblemaIdCodi";
import { PostJutgeActivitatIdProblema } from "../../../../dao/jutge/PostJutgeActivitatIdProblema";
import dayjs from "dayjs";
import ExamenModal2 from "./ExamenModal2";
import DependenciaModal from "./DependenciaModal";
import EnunciatModal from "./EnunciatModal";
import {
    TrophyOutlined, CheckCircleOutlined, LockOutlined, UnlockOutlined,
    BugOutlined, GiftOutlined, MoreOutlined, SearchOutlined, ReloadOutlined,
    CodeOutlined, FireOutlined, ThunderboltOutlined, AreaChartOutlined,
    FileExcelOutlined
} from '@ant-design/icons';
import ImportarExerciciExcelModal from "./ImportarExerciciExcelModal";
import { PostClaimReward } from "../../../../dao/jutge/PostClaimReward";
import { GetJutgeUsuariIdJavamons } from "../../../../dao/jutge/GetJutgeUsuariIdJavamons";

// Solo en desarrollo local: habilita el botón de forzar recompensa (ignora requisitos).
const IS_LOCALHOST = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
import { GetActivityJavamonStatus } from "../../../../dao/jutge/GetActivityJavamonStatus";
import { PostUseCandadoJavamon } from "../../../../dao/jutge/PostUseCandadoJavamon";
import { PostUseTestJavamon } from "../../../../dao/jutge/PostUseTestJavamon";
import { FaUnlock, FaListAlt } from "react-icons/fa";
import { Modal, message } from "antd";
import JavaMon from "../../problemesId/content/JavaMon";
import { GetProblemaRecompenses } from "../../../../dao/jutge/GetProblemaRecompenses";
import { GetJavamonConfig } from "../../../../dao/jutge/GetJavamonConfig";
import { AssignJavamonToUser } from "../../../../dao/jutge/UserInventoryAdminDAO";
import RecompensaSummaryModal from "./RecompensaSummaryModal";
import { GiCrossedSwords } from "react-icons/gi";
import { DesktopOutlined, ExportOutlined } from "@ant-design/icons";
import { GetUsuarisRecompensesProblema } from "../../../../dao/jutge/GetUsuarisRecompensesProblema";
import { FaUsers } from "react-icons/fa";
import ModoDesafioTag from "./ModoDesafioTag";
import ProblemaIdAlumnes from "../../problemesId/content/ProblemaIdAlumnes";

const { Title, Text } = Typography;

const RecompensesTags: React.FC<{ id_problema: string; idActivitat?: string; isUnlocked: boolean; ele: any; refreshKey?: number; modoDesafio?: boolean; }> = ({ id_problema, idActivitat, isUnlocked, ele, refreshKey = 0, modoDesafio = false }) => {
    const { user } = useContext(AuthContext);
    const isAlumne = user?.tipus === "2";
    const isCompleted = (ele?.progres ?? 0) >= 1;
    const [recs, setRecs] = useState<any[]>([]);
    const [usuaris, setUsuaris] = useState<any[]>([]);

    useEffect(() => {
        if (!isUnlocked) return;
        let mounted = true;
        // Pasamos idActivitat para que el claimed_count ("Agotada") y el historial (whoGotIt)
        // se cuenten/filtren POR AULA (la de la actividad), sin cruce con otras aulas.
        GetProblemaRecompenses(id_problema, idActivitat).then(res => {
            if (mounted && res && Array.isArray(res)) setRecs(res);
        }).catch(() => { });
        GetUsuarisRecompensesProblema(id_problema, idActivitat).then(res => {
            if (mounted && res && Array.isArray(res)) setUsuaris(res);
        }).catch(() => { });
        return () => { mounted = false; };
    }, [id_problema, idActivitat, isUnlocked, refreshKey]);

    if (!isUnlocked || !recs || recs.length === 0) return null;

    const myAttempts = ele?.intents || ele?.enviament_count || 0;

    const visibleItems = recs.map((r: any) => {
        // En Modo Desafío, los javamons de problemas son exclusivos del modo juego de Unity
        // y NO deben aparecer en las etiquetas de recompensas de la tabla del modo desafío.
        if (modoDesafio && r.tipo && r.tipo.startsWith('JAVAMON')) {
            return null;
        }

        let isExhausted = false;
        let exhaustionReason = '';
        let whoGotIt = '';
        let isClaimedByMe = false;

        // Check exhaustion / claim status
        const gotItUsers = usuaris.filter(u => {
            try {
                const uRewards = typeof u.rewards_json === 'string' ? JSON.parse(u.rewards_json) : u.rewards_json;
                return uRewards && Array.isArray(uRewards) && uRewards.some((ur: any) => ur.id === r.id);
            } catch (e) {
                return false;
            }
        });

        if (r.limit_quantity && r.limit_quantity > 0 && r.claimed_count >= r.limit_quantity) {
            isExhausted = true;
            exhaustionReason = 'Agotada';
            if (gotItUsers.length > 0) {
                whoGotIt = gotItUsers.map(u => u.nom).join(', ');
                exhaustionReason += ` (${whoGotIt})`;
            }
        } else if (r.intentos_min && myAttempts > 0 && myAttempts < r.intentos_min) {
            isExhausted = true;
            exhaustionReason = `Requereix ${r.intentos_min} intents (Llevas ${myAttempts})`;
        } else if (r.intentos_max && myAttempts > r.intentos_max) {
            isExhausted = true;
            exhaustionReason = `Límit d'intents superat (Màx ${r.intentos_max}, Llevas ${myAttempts})`;
        } else if (r.time_limit && ele?.tiempo_empleado_segundos && ele.tiempo_empleado_segundos > (r.time_limit * 60)) {
            isExhausted = true;
            const elapsedMin = Math.round(ele.tiempo_empleado_segundos / 60);
            exhaustionReason = `Temps límit superat (Màx ${r.time_limit} min, has trigat ${elapsedMin} min)`;
        }

        // Check if claimed by current user
        isClaimedByMe = gotItUsers.some(u => String(u.id) === String((user as any)?.id || (user as any)?.idUsuari));

        // --- REGLAS DE VISIBILIDAD PARA ALUMNOS ---
        if (isAlumne) {
            if (r.tipo === 'JAVAMON_RANDOM' || r.tipo === 'JAVAMON_SEASON') {
                return null;
            }

            if (r.tipo === 'JAVAMON') {
                const resueltoEnJuego = ele?.origen_success === 2 || ele?.origen_success === "2";
                if (!(isCompleted && resueltoEnJuego)) {
                    return null;
                }
            } else {
                const isPuntuacioOrTrofeu = r.tipo === 'PUNTUACION' || r.tipo === 'TROFEO';
                if (!isPuntuacioOrTrofeu && !isCompleted && !isExhausted && !isClaimedByMe) {
                    return null;
                }
            }
        }

        let text = r.tipo === 'JAVAMON_RANDOM'
            ? 'Javamon Aleatori'
            : (r.tipo === 'JAVAMON_SEASON' ? 'Javamon de Temporada' : r.tipo);
        if (r.valor && r.valor > 1) text += ` x${r.valor}`;

        const hasImage = r.imagen && r.imagen.length > 0;
        let imgSrc = '';
        if (hasImage) {
            imgSrc = r.imagen.startsWith('data:') || r.imagen.startsWith('http') ? r.imagen : `data:image/png;base64,${r.imagen}`;
        } else if (r.id_item && !['PUNTUACION', 'JAVAMON_RANDOM', 'JAVAMON_SEASON'].includes(r.tipo)) {
            const apiUrl = process.env.REACT_APP_API_URL;
            let typeSegment = r.tipo.toLowerCase();
            if (typeSegment === "escudo") typeSegment = "escut";
            if (typeSegment === "arco") typeSegment = "arc";
            if (typeSegment === "shop_item") typeSegment = "shop";
            imgSrc = `${apiUrl}:8061/jutge/game/image/${typeSegment}/${r.id_item}`;
        }

        let content;
        let bgColor = "transparent";
        let borderColor = "gray";

        if (r.tipo === 'PUNTUACION') {
            content = <span style={{ color: 'gold', fontWeight: 'bold' }}>🪙 +{r.valor}</span>;
            bgColor = "black";
            borderColor = "#333";
        } else if (r.tipo === 'JAVAMON_RANDOM') {
            content = <span>⚔️</span>;
            bgColor = "#fff";
            borderColor = "#d9363e";
        } else if (r.tipo === 'JAVAMON_SEASON') {
            content = <span style={{ color: '#722ed1', fontWeight: 'bold' }}>❓</span>;
            bgColor = "#f9f0ff";
            borderColor = "#722ed1";
        } else if (imgSrc) {
            content = <img src={imgSrc} alt={r.tipo} style={{ width: 16, height: 16, objectFit: 'contain', borderRadius: r.tipo.includes('JAVAMON') ? '50%' : '0' }} />;
        } else {
            content = <span>🎁</span>;
        }

        return {
            ...r,
            renderedContent: content,
            tooltipTitle: isExhausted ? exhaustionReason : text,
            isExhausted,
            exhaustionReason,
            bgColor,
            borderColor,
            grupoNum: Number(r.grupo_seleccion) || 0
        };
    }).filter(Boolean);

    // Agrupar recompensas que pertenezcan a un mismo grupo de selección (grupoNum > 0)
    const groupedElements: React.ReactNode[] = [];
    const processedGroupIds = new Set<number>();

    visibleItems.forEach((item: any, idx: number) => {
        if (item.grupoNum > 0) {
            if (processedGroupIds.has(item.grupoNum)) return;
            processedGroupIds.add(item.grupoNum);

            const groupItems = visibleItems.filter((x: any) => x.grupoNum === item.grupoNum);
            const allExhausted = groupItems.every((x: any) => x.isExhausted);
            const groupTooltip = (
                <div>
                    <div style={{ fontWeight: 600, marginBottom: 4 }}>🎯 Recompensa unificada (Tria 1 del Grup {item.grupoNum}):</div>
                    {groupItems.map((gi: any, gIdx: number) => (
                        <div key={gi.id || gIdx}>• {gi.tooltipTitle}</div>
                    ))}
                </div>
            );

            groupedElements.push(
                <Tooltip key={`group-${item.grupoNum}`} title={groupTooltip}>
                    <Tag
                        style={{
                            fontSize: '0.75rem',
                            borderRadius: '8px',
                            padding: '0 6px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '4px',
                            background: '#f0f5ff',
                            border: '1px solid #adc6ff',
                            cursor: 'help',
                            opacity: allExhausted ? 0.4 : 1,
                            filter: allExhausted ? 'grayscale(100%)' : 'none'
                        }}
                    >
                        <span style={{ fontSize: '10px', color: '#1d39c4', fontWeight: 600, marginRight: 2 }}>
                            G{item.grupoNum}:
                        </span>
                        {groupItems.map((gi: any, gIdx: number) => (
                            <span
                                key={gi.id || gIdx}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    opacity: gi.isExhausted ? 0.35 : 1,
                                    textDecoration: gi.isExhausted ? 'line-through' : 'none'
                                }}
                            >
                                {gi.renderedContent}
                            </span>
                        ))}
                    </Tag>
                </Tooltip>
            );
        } else {
            groupedElements.push(
                <Tooltip key={item.id || idx} title={item.tooltipTitle}>
                    <Tag
                        color={item.bgColor}
                        style={{
                            fontSize: '0.75rem',
                            borderRadius: '8px',
                            padding: '0 4px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: `1px solid ${item.borderColor}`,
                            cursor: 'help',
                            opacity: item.isExhausted ? 0.4 : 1,
                            textDecoration: item.isExhausted ? 'line-through' : 'none',
                            filter: item.isExhausted ? 'grayscale(100%)' : 'none'
                        }}
                    >
                        {item.renderedContent}
                    </Tag>
                </Tooltip>
            );
        }
    });

    return (
        <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
            {groupedElements}
        </div>
    );
};

interface ActivitatsIdExercicisProps {
    isGameModal?: boolean;
}

const ActivitatsIdExercicis: React.FC<ActivitatsIdExercicisProps> = ({ isGameModal = false }) => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne, setUser } = useContext(AuthContext);
    const { id_activitat } = useParams();
    const [modoDesafio, setModoDesafio] = useState<boolean>(isGameModal ? true : ((user as any)?.modoDesafio === 1 || (user as any)?.modoDesafio === true));
    const [dades, setDades] = useState<any>();
    const [activeTab, setActiveTab] = useState<string>('rankings');
    const [claimedJavamon, setClaimedJavamon] = useState<any>(null);
    const [activitat, setActivitat] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalNuevo, setModalNuevo] = useState(false);
    const [modalTestNuevo, setModalTestNuevo] = useState(false);
    const [selected, setSelected] = useState<any>();
    const navigate = useNavigate();
    const [modalExamen, setModalExamen] = useState(false);
    const [rankingsVisible, setRankingsVisible] = useState(false);
    const [modalDependencia, setModalDependencia] = useState(false);
    const [modalEnunciat, setModalEnunciat] = useState(false);
    // Modal del professor per veure les entregues dels alumnes (ProblemaIdAlumnes)
    const [modalAlumnes, setModalAlumnes] = useState(false);
    const [incenseTimeLeft, setIncenseTimeLeft] = useState<string | null>(null);
    const [userJavamons, setUserJavamons] = useState<any[]>([]);
    const [javamonStatus, setJavamonStatus] = useState<any>(null);
    const [testsReadOnly, setTestsReadOnly] = useState(false);
    const [importExcelVisible, setImportExcelVisible] = useState(false);

    // Reward Modal state
    const [recompensaModalVisible, setRecompensaModalVisible] = useState(false);
    const [recompensaItems, setRecompensaItems] = useState<any[]>([]);
    const [selectableMode, setSelectableMode] = useState(false);
    const [selectionOptions, setSelectionOptions] = useState<any[]>([]);
    const [pendingSelectionItem, setPendingSelectionItem] = useState<any>(null);
    const [showBattle, setShowBattle] = useState(false);
    const [showJavamonNotaModal, setShowJavamonNotaModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [battleJavamon, setBattleJavamon] = useState<any>(null);
    const [pendingJavamonBattle, setPendingJavamonBattle] = useState<any>(null);
    const [activeRewardData, setActiveRewardData] = useState<any>(null);

    // Exam Modal state
    const [ideStartModalVisible, setIdeStartModalVisible] = useState(false);
    const [ideStartLoading, setIdeStartLoading] = useState(false);
    const [ideStartUrl, setIdeStartUrl] = useState('');
    const [ideStartTheiaUrl, setIdeStartTheiaUrl] = useState('');
    const [ideStartExamEl, setIdeStartExamEl] = useState<any>(null);
    const [ideStartError, setIdeStartError] = useState<string | null>(null);
    const startDesafioModal = async (ele: any) => {
        setIdeStartExamEl(ele);
        setIdeStartModalVisible(true);
        setIdeStartLoading(true);
        setIdeStartUrl('');
        setIdeStartError(null);
        startExamProcess(ele);
    };

    const startExamProcess = async (ele: any) => {
        setIdeStartLoading(true);
        setIdeStartUrl('');
        setIdeStartError(null);
        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
            const token = localStorage.getItem('authToken');

            // Provision IDE — poll until ready, retrying on transient fetch/network errors too
            const folderName = ele.prac || ele.nom || `Ejercicio_${ele.id}`;
            let attempts = 0;
            const maxAttempts = 60; // 60 × 5s = 5 minutes max

            while (attempts < maxAttempts) {
                let startRes: Response;
                try {
                    const aulaParam = activitat?.id_aula ? `&id_aula=${activitat.id_aula}` : '';
                    const practicaParam = id_activitat ? `&id_practica=${id_activitat}` : '';
                    startRes = await fetch(
                        `${baseUrl}/jutge/theia/port?id_usuari=${userId}&folder=${encodeURIComponent(folderName)}&id_problema=${ele.id}${practicaParam}${aulaParam}&admin=true`,
                        { headers: { 'Authorization': `Bearer ${token}` } }
                    );
                } catch (fetchErr) {
                    // Network / timeout error — Docker may still be starting; retry
                    attempts++;
                    await new Promise(resolve => setTimeout(resolve, 5000));
                    continue;
                }

                if (!startRes.ok) {
                    // HTTP error from server — wait and retry instead of bailing out immediately
                    let errorMessage = `HTTP ${startRes.status}`;
                    try {
                        const errData = await startRes.json();
                        if (errData && errData.error) errorMessage = errData.error;
                    } catch (e) { }
                    attempts++;
                    if (attempts >= maxAttempts) throw new Error(errorMessage);
                    await new Promise(resolve => setTimeout(resolve, 5000));
                    continue;
                }

                const data = await startRes.json();

                if (data.status === 'provisioning' || data.hostname === 'Pending...' || data.port === 0) {
                    attempts++;
                    await new Promise(resolve => setTimeout(resolve, 5000));
                    continue;
                }

                const projectName = data.normalizedProjectName;
                let theiaBase = data.httpsUrl || `http://${data.hostname || window.location.hostname}:${data.port}`;
                if (theiaBase.endsWith("/")) theiaBase = theiaBase.slice(0, -1);

                let theiaUrl = projectName
                    ? `${theiaBase}/#/mnt/efs/${userId}/${projectName}`
                    : `${theiaBase}/#/mnt/efs/${userId}`;

                setIdeStartTheiaUrl(theiaUrl);

                const examWrapperUrl = `${window.location.origin}/ide/exam-v2?url=${encodeURIComponent(theiaUrl)}&idPractica=${id_activitat}&idProblema=${ele.id}&openPanel=enunciat`;
                setIdeStartUrl(examWrapperUrl);
                setIdeStartLoading(false);
                return;
            }

            throw new Error("S'ha superat el temps d'espera per provisionar l'IDE.");
        } catch (e: any) {
            console.error(e);
            setIdeStartLoading(false);
            setIdeStartError(e.message || 'Error desconocido al preparar el entorno.');
        }
    };

    useEffect(() => {
        const checkIncense = () => {
            const expiry = localStorage.getItem('incense_expiry');
            if (expiry) {
                const diff = parseInt(expiry) - Date.now();
                if (diff > 0) {
                    const mins = Math.floor(diff / 60000);
                    const secs = Math.floor((diff % 60000) / 1000);
                    setIncenseTimeLeft(`${mins}m ${secs}s`);
                } else {
                    setIncenseTimeLeft(null);
                    localStorage.removeItem('incense_expiry');
                }
            } else {
                setIncenseTimeLeft(null);
            }
        };

        checkIncense(); // Initial check
        const interval = setInterval(checkIncense, 1000);

        // Listen for storage events (if user activates in another tab/component)
        const handleStorage = () => checkIncense();
        window.addEventListener('storage', handleStorage);

        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', handleStorage);
        };
    }, []);

    const handleToggleModoDesafio = async (checked: boolean) => {
        try {
            await import('../../../../dao/PutModoDesafio').then(m => m.PutModoDesafio(userId, checked));
            setModoDesafio(checked);
            if (setUser) {
                setUser({ ...(user as any), modoDesafio: checked ? 1 : 0 });
            }
            import("antd").then(({ message }) => message.success(`Modo Desafío ${checked ? 'Activado' : 'Desactivado'}`));
        } catch (e) {
            import("antd").then(({ message }) => message.error("Error al actualizar el Modo Desafío"));
        }
    };

    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_activitat]);

    async function checkDades() {
        setLoading(true);
        try {
            // Càrrega concurrent inicial per màxima agilitat
            const [act, prac, data, jm, st] = await Promise.all([
                GetPractica(id_activitat + "").catch(() => null),
                GetUsuariIdJutgeActivitats(userId).catch(() => []),
                GetUsuariIdJutgeActivitatsId(userId + "", id_activitat + "").catch(() => []),
                GetJutgeUsuariIdJavamons(userId + "").catch(() => []),
                GetActivityJavamonStatus(id_activitat + "", userId + "").catch(() => null)
            ]);

            const actividad = Array.isArray(prac) ? prac.find((a: any) => a.id === Number(id_activitat)) : undefined;
            const now = new Date();
            const start = act?.inici ? new Date(act.inici) : (actividad?.inici ? new Date(actividad.inici) : null);

            // Si no existe, es borrador (1) o aún no ha llegado la fecha de apertura
            if (user.tipus !== "0" && user.tipus !== "1") {
                if (!act || act.estat === 1 || (start && start > now)) {
                    if (!isGameModal) {
                        navigate('/jutge/activitats');
                    }
                    return;
                }
            }

            if (jm) setUserJavamons(jm || []);
            if (st) setJavamonStatus(st);

            if (actividad && !isGameModal) {
                setBreadCrumb(
                    [
                        { nom: 'Home', nav: '/home' },
                        { nom: 'jutge', nav: '/jutge' },
                        { nom: 'activitats', nav: `/jutge/activitats` },
                        { nom: `${actividad.nom}`, nav: `/jutge/activitats/${id_activitat}` }
                    ],
                    true
                );
            }

            setActivitat({ ...(act || {}), final: actividad?.final || act?.final });
            setDades(data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    const hasCandado = userJavamons.some(j => j.descr && j.descr.includes('CANDADO') && (j.used === 0 || !j.used));
    const hasTest = userJavamons.some(j => j.descr && j.descr.includes('TEST') && (j.used === 0 || !j.used));

    const [selectionModal, setSelectionModal] = useState<{ visible: boolean, type: 'CANDADO' | 'TEST', problem: any }>({ visible: false, type: 'CANDADO', problem: null });

    // Dependencia de Juego: la marca "-1" puede ir sola o combinada con ids (ej: "-1,5,7").
    // El ejercicio solo es visible dentro del juego / modo desafío cuando lleva esta marca.
    function esDependenciaDeJuego(ele: any) {
        const raw = ele?.depende;
        if (raw === null || raw === undefined) return false;
        return String(raw).split(",").map((s: string) => s.trim()).includes("-1");
    }

    // Convierte el valor crudo de 'depende' (null | "-1" | "5" | "5,7,9" | "-1,5,7") en la lista
    // de ids prerequisito (strings). La marca de juego (-1) se descarta (el filtro \d+ la excluye).
    function idsDependencia(ele: any): string[] {
        const raw = ele?.depende;
        if (raw === null || raw === undefined || raw === "" || raw === 0 || raw === "0") return [];
        return String(raw).split(",").map((s: string) => s.trim()).filter((s: string) => /^\d+$/.test(s) && s !== "0");
    }

    function dependenciaCumplida(ele: any) {
        if (user.tipus === "1" || user.tipus === "0") return true;

        if (javamonStatus?.candado?.some((c: any) => c.idProblema === ele.id)) return true;

        if (!ele.depende) return true;

        // Si es dependencia de juego, solo es accesible desde el juego (o profesores/admin).
        if (esDependenciaDeJuego(ele) && !isGameModal) {
            return false;
        }

        // AND: ademas, hay que haber completado (progres >= 1) TODOS los prerequisitos (si los hay).
        const ids = idsDependencia(ele);
        if (ids.length === 0) return true;

        return ids.every((depId: string) => {
            const ejercicioDependencia = dades?.find((e: any) => (e.id + "") === depId);
            return !!ejercicioDependencia && ejercicioDependencia.progres >= 1;
        });
    }

    function checkElement(ele: any) {
        setSelected(ele);
        setModal(true);
    }

    function openSelectionModal(type: 'CANDADO' | 'TEST', problem: any) {
        setSelectionModal({ visible: true, type, problem });
    }

    async function handleUseJavamon(javamon: any) {
        const { type, problem } = selectionModal;
        if (!problem || !javamon) return;

        let success = false;
        if (type === 'CANDADO') {
            success = await PostUseCandadoJavamon(id_activitat + "", problem.id + "", userId + "", javamon.id + "");
        } else {
            success = await PostUseTestJavamon(id_activitat + "", problem.id + "", userId + "", javamon.id + "");
        }

        if (success) {
            await checkDades();
            setSelectionModal({ ...selectionModal, visible: false });
            Modal.success({ content: `${type === 'CANDADO' ? 'Ejercicio desbloqueado' : 'Tests visualizables'} con ${javamon.nom}!` });
        }
    }

    // Helper to get available Javamons for modal
    const availableJavamons = activitat?.is_concurs ? [] : userJavamons.filter(j =>
        j.descr &&
        j.descr.includes(selectionModal.type) &&
        (j.used === 0 || !j.used)
    );

    async function reclamar(ele: any) {
        setLoading(true);
        await PutUsuariIdActivitatId(userId + "", ele.id + "");
        await checkDades();
    }

    async function nuevo() {
        setSelected({ id: 0 });
        setModalNuevo(true);
    }

    async function nouTestModal(ele: any, readOnly: boolean = false) {
        setSelected(ele);
        setTestsReadOnly(readOnly);
        setModalTestNuevo(true);
    }

    function estaBloqueadoPorDependencia(ele: any) {
        return !!ele.depende && !dependenciaCumplida(ele);
    }

    async function editar(ele: any) {
        setSelected({
            ...ele,
            nom: ele.prac,
            descripcio: ele.enunciat
        });
        setModalNuevo(true);
    }

    function closeModal() {
        setModal(false);
        setLoading(false);
    }

    async function closeNouModal(refresh: boolean) {
        setModalNuevo(false);
        if (refresh) await checkDades();
        else setLoading(false);
    }

    async function closeNouTestModal(refresh: boolean) {
        setModalTestNuevo(false);
        if (refresh) await checkDades();
        else setLoading(false);
    }

    async function closeModalRanking(refresh: boolean) {
        setRankingsVisible(false);
        if (refresh) {
            await checkDades();
            setRefreshKey(prev => prev + 1);
        }
        else setLoading(false);
    }
    async function closeModalDependencia(refresh: boolean) {
        setModalDependencia(false);
        if (refresh) await checkDades();
        else setLoading(false);
    }

    function verEnunciado(ele: any) {
        setSelected(ele);
        setModalEnunciat(true);
    }

    function rankings(ele: any) {
        setSelected(ele);
        setRankingsVisible(true);
    }

    // Obre el modal amb les entregues dels alumnes per a aquest problema
    function veureAlumnes(ele: any) {
        setSelected(ele);
        setModalAlumnes(true);
    }

    function gestionDependencia(ele: any) {
        setSelected(ele);
        setModalDependencia(true);
    }

    function potVeureTrofeus(ele: any) {
        if (user.tipus === "0" || user.tipus === "1") return true;
        if (alumne?.alumne?.repetidor) return false;

        const avui = new Date(ele.now);
        const inici = ele.inici ? new Date(ele.inici) : null;

        // Si no hay fecha de inicio, NO se muestran los trofeos
        if (!inici) return true;

        return avui >= inici;
    }

    const handleQuickChangeDate = async (record: any, field: 'inici' | 'final', newDate: any) => {
        try {
            const formattedDate = newDate
                ? newDate.format('YYYY-MM-DD HH:mm:ss')
                : null;

            const existingInici = record.inici
                ? dayjs(record.inici.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss')
                : null;
            const existingFinal = record.final
                ? dayjs(record.final.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss')
                : null;

            // IMPORTANT: el proc post_problema_activitat fa un UPDATE de TOTS els camps
            // (nom, descripcio, dificultat, entrada, sortida, tags, inici, final, multi,
            // puntuacion). Si no els reenviem, els machaca a buit. Per això preservem tots
            // els valors actuals del record i només canviem la data.
            // NOTA: a l'objecte 'record' l'enunciat/descripció ve com 'enunciat'.
            const payload: any = {
                id: record.id,
                nom: record.nom || record.prac,
                descripcio: record.descripcio ?? record.enunciat ?? '',
                dificultat: record.dificultat ?? '',
                entrada: record.entrada ?? '',
                sortida: record.sortida ?? '',
                tags: record.tags ?? '',
                puntuacion: record.puntuacion ?? 0,
                multi: record.multi,
                inici: field === 'inici' ? formattedDate : existingInici,
                fin: field === 'final' ? formattedDate : existingFinal
            };

            const targetAct = id_activitat && id_activitat !== "undefined" ? id_activitat : "0";
            await PostJutgeActivitatIdProblema(targetAct, payload);

            message.success(`Data ${field === 'inici' ? "d'inici" : 'final'} actualitzada correctament`);

            // Actualitzem l'estat local
            setDades((prev: any[]) =>
                (prev || []).map((item) => {
                    if (item.id === record.id) {
                        return {
                            ...item,
                            [field]: newDate ? newDate.format('YYYY-MM-DD HH:mm:ss') : null
                        };
                    }
                    return item;
                })
            );
        } catch (e) {
            console.error('Error actualitzant data de l\'exercici:', e);
            message.error("Error al desar la nova data");
        }
    };

    async function modoExamen(ele: any) {
        setLoading(true);

        try {
            // Llamar al endpoint para obtener el código guardado
            const codiResponse = await GetJutgeActivitatIdProblemaIdCodi(
                id_activitat + "", // id de la práctica
                ele.id,            // id del problema
                userId + ""        // id del usuario
            );

            // Si no existe código, dejamos null
            const codi = codiResponse?.codi ?? null;

            // Actualizar el selected con la propiedad 'codi'
            setSelected({
                ...ele,
                codi
            });

            // Abrir el modal
            setModalExamen(true);

        } catch (err) {
            console.error("Error obteniendo código guardado:", err);
            // Aunque falle, abrimos el modal con codi nulo
            setSelected({
                ...ele,
                codi: null
            });
            setModalExamen(true);
        } finally {
            setLoading(false);
        }
    }

    function canShowAccessButton(ele: any) {
        if (isGameModal) return false; // En el juego (modal interactuable), la pantalla es solo para visualización sin botones de acceder
        if (!activitat || !ele) return false;

        const isExamen = activitat?.isExamen === 1;
        if (isExamen) return false; // Examen logic handled separately

        const isAdmin = ["0", "1"].includes(user.tipus);
        if (isAdmin) return true;

        const isFinished = ele.progres >= 1;
        if (isFinished) return false;

        const isActive = activitat.estat === 3;
        const isExtended = ele.extended && activitat.estat !== 1 && (!activitat.final || new Date(ele.now).getTime() <= new Date(activitat.final).getTime() + 86400000);

        const basicAccess = isActive || isExtended;

        return basicAccess && potAccedir(ele) && dependenciaCumplida(ele);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 75,
            align: 'center',
            sorter: (a, b) => a.id - b.id,
            render: (id) => (
                <Tag style={{
                    borderRadius: 6,
                    fontWeight: 700,
                    fontSize: 12,
                    padding: '2px 8px',
                    background: '#f0f5ff',
                    borderColor: '#adc6ff',
                    color: '#2f54eb'
                }}>
                    #{id}
                </Tag>
            )
        }, {
            key: 'prac_info',
            title: 'Exercici',
            dataIndex: 'prac',
            width: 280,
            sorter: (a, b) => (a.prac || '').localeCompare(b.prac || ''),
            render: (text, ele) => {
                const inici = ele.inici ? new Date(ele.inici).toLocaleString('es-ES') : null;
                const final = ele.final ? new Date(ele.final).toLocaleString('es-ES') : null;

                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {/* 🔹 Nombre del ejercicio */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <strong style={{ fontSize: '1rem', color: JutgeColors.colors.color5 }}>
                                {text}
                            </strong>
                            {(["0", "1"].includes(user.tipus) && ele.multi === 1) && (
                                <Tooltip title="Este ejercicio es de multifichero (uno de ellos con main)">
                                    <Tag color="purple" style={{ fontSize: '0.7rem', margin: 0, cursor: 'help' }}>Multi</Tag>
                                </Tooltip>
                            )}
                            {((["0", "1"].includes(user.tipus) || ele.progres >= 1) && esDependenciaDeJuego(ele)) && (
                                <Tooltip title="Ejercicio de Unity / Juego">
                                    <Tag color="magenta" style={{ fontSize: '0.7rem', margin: 0, cursor: 'help' }}>🎮 Solo Juego</Tag>
                                </Tooltip>
                            )}
                        </div>

                        {/* 🔹 Fechas debajo del título */}
                        {["0", "1"].includes(user.tipus) ? (
                            <div
                                style={{ display: 'flex', gap: '8px', marginTop: '4px', alignItems: 'center' }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Tooltip title="Fes clic per modificar la data d'inici">
                                    <div style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: ele.inici ? '#f6ffed' : 'transparent',
                                        borderRadius: 4,
                                        padding: '0 6px',
                                        height: 22
                                    }}>
                                        <DatePicker
                                            size="small"
                                            showTime={{ format: 'HH:mm' }}
                                            format="DD/MM/YYYY HH:mm"
                                            value={ele.inici ? dayjs(ele.inici.toString().substring(0, 19)) : null}
                                            onChange={(date) => handleQuickChangeDate(ele, 'inici', date)}
                                            allowClear
                                            placeholder="Sense inici"
                                            style={{
                                                padding: 0,
                                                border: 'none',
                                                background: 'transparent',
                                                cursor: 'pointer',
                                                width: ele.inici ? 'auto' : 85,
                                                fontSize: '0.75rem',
                                                color: ele.inici ? '#389e0d' : undefined
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Fes clic per modificar la data final">
                                    <div style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: ele.final ? '#fff1f0' : 'transparent',
                                        borderRadius: 4,
                                        padding: '0 6px',
                                        height: 22
                                    }}>
                                        <DatePicker
                                            size="small"
                                            showTime={{ format: 'HH:mm' }}
                                            format="DD/MM/YYYY HH:mm"
                                            value={ele.final ? dayjs(ele.final.toString().substring(0, 19)) : null}
                                            onChange={(date) => handleQuickChangeDate(ele, 'final', date)}
                                            allowClear
                                            placeholder="Sense final"
                                            style={{
                                                padding: 0,
                                                border: 'none',
                                                background: 'transparent',
                                                cursor: 'pointer',
                                                width: ele.final ? 'auto' : 85,
                                                fontSize: '0.75rem',
                                                color: ele.final ? '#cf1322' : undefined
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                {inici && <span style={{ fontSize: '0.3rem', color: '#555' }}><Tag color={"green"}>{inici}</Tag></span>}
                                {final && <span style={{ fontSize: '0.3rem', color: '#555' }}><Tag color={"red"}>{final}</Tag></span>}
                            </div>
                        )}
                    </div>
                );
            },
        },
        {
            key: 'tags_trofeus',
            title: 'Etiquetes & Recompenses',
            dataIndex: 'prac',
            width: 250,
            render: (text, ele) => {
                const tags = ele?.tags ? ele.tags.split(' ') : [];

                // Colores alternados usando los tonos de JutgeColors
                const tagColors = [
                    JutgeColors.colors.color1,
                    JutgeColors.colors.color2,
                    JutgeColors.colors.color3,
                    JutgeColors.colors.color4,
                    JutgeColors.colors.color5,
                ];

                return (
                    <div>
                        {/* 🔸 Tags */}
                        <div style={{ marginTop: '2px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                            {tags.map((t: string, i: number) => (
                                <Tag
                                    key={i}
                                    color={tagColors[t.length % tagColors.length]}
                                    style={{
                                        fontSize: '0.75rem',
                                        borderRadius: '6px',
                                        padding: '0 6px',
                                        margin: 0
                                    }}
                                >
                                    {t}
                                </Tag>
                            ))}
                        </div>

                        {/* 🏆 TROFEOS i PUNTUACIÓ (solo visibles si ha llegado la fecha de inicio) */}
                        {potVeureTrofeus(ele) &&
                            dependenciaCumplida(ele) &&
                            ((ele.trofeus && ele.trofeus.length > 0) || (ele.puntuacion > 1)) && (

                                <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                                    {ele.puntuacion > 1 && (
                                        <Tooltip title={`Per completar aquest exercici es guanyen ${ele.puntuacion} punts de prestigi`}>
                                            <Tag
                                                color="black"
                                                style={{
                                                    fontSize: '0.75rem',
                                                    borderRadius: '8px',
                                                    padding: '0 6px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    border: '1px solid #333',
                                                    cursor: 'help'
                                                }}
                                            >
                                                +{ele.puntuacion} <TrophyOutlined style={{ color: 'gold', fontSize: '10px' }} />
                                            </Tag>
                                        </Tooltip>
                                    )}
                                    {ele.trofeus && ele.trofeus.map((t: any) => {
                                        const isClaimed = t.claimed === 1;
                                        const isDesafioOrGame = ele?.origen_success === 1 || ele?.origen_success === 2 ||
                                            ele?.origen_success === "1" || ele?.origen_success === "2";
                                        const isMe = t.is_me === 1 && isDesafioOrGame;
                                        let tooltip = isClaimed ? `Guanyador: ${t.winner}` : "Disponible";
                                        if (isMe) tooltip = "🏆 Guanyat per tu!";

                                        return (
                                            <Tooltip key={t.id} title={tooltip}>
                                                <Tag
                                                    color={t.color}
                                                    style={{
                                                        fontSize: '0.75rem',
                                                        borderRadius: '8px',
                                                        padding: '0 6px',
                                                        fontWeight: 'bold',
                                                        textDecoration: isClaimed && !isMe ? 'line-through' : 'none',
                                                        opacity: isClaimed && !isMe ? 0.6 : 1,
                                                        border: isMe ? '2px solid gold' : '1px solid transparent',
                                                        boxShadow: isMe ? '0 0 4px gold' : 'none',
                                                    }}
                                                >
                                                    {t.nom} {isMe && "👑"}
                                                </Tag>
                                            </Tooltip>
                                        );
                                    })}
                                </div>
                            )}

                        <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                            <RecompensesTags
                                id_problema={ele.id + ""}
                                idActivitat={id_activitat + ""}
                                isUnlocked={potAccedir(ele) && dependenciaCumplida(ele)}
                                ele={ele}
                                refreshKey={refreshKey}
                                modoDesafio={modoDesafio}
                            />
                        </div>
                    </div>
                );

            },
        },
        {
            key: 'dificultat',
            dataIndex: 'dificultat',
            title: 'Dificultat',
            width: 100,
            align: 'center',
            sorter: (a, b) => (a.dificultat || '').localeCompare(b.dificultat || ''),
            render: (dificultat) => {
                let color = '';
                switch ((dificultat || '').toLowerCase()) {
                    case 'begginer':
                        color = JutgeColors.colors.color5; // verde
                        break;
                    case 'intermediate':
                        color = JutgeColors.colors.color3; // naranja
                        break;
                    case 'expert':
                        color = JutgeColors.colors.color1; // rojo
                        break;
                    default:
                        color = JutgeColors.colors.color3; // color por defecto
                }

                return (
                    <Tag
                        color={color}
                        style={{
                            fontSize: '0.75rem',
                            borderRadius: '6px',
                            fontWeight: 600,
                            padding: '2px 8px',
                        }}
                    >
                        {dificultat || 'N/D'}
                    </Tag>
                );
            },
        },
        {
            key: 'progres',
            title: 'Estat / Progrés',
            dataIndex: 'intents',
            width: 130,
            align: 'center',
            sorter: (a, b) => (a.progres || 0) - (b.progres || 0),
            render: (e, ele) => {
                // Determinamos si tu progreso está completo o no
                const hecho = ele.progres * 100 === 100;
                const progreso = ele.progres ?? 0;

                return (
                    activitat?.isExamen === 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {hecho ? (
                                    <Tag color="success" style={{ fontWeight: 700, borderRadius: 6, display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <CheckCircleOutlined /> Superat
                                    </Tag>
                                ) : (
                                    <Progress
                                        percent={Math.trunc(progreso * 100)}
                                        strokeColor={{
                                            '0%': JutgeColors.colors.color1,
                                            '50%': JutgeColors.colors.color2,
                                            '100%': JutgeColors.colors.color5,
                                        }}
                                        showInfo={true}
                                        strokeWidth={10}
                                    />
                                )}
                            </div>
                        </div>
                    ) : <Tag
                        style={{
                            fontSize: '0.8rem',
                            borderRadius: '8px',
                            padding: '0 8px',
                        }}
                        color={ele.intents > 0 ? "green" : "gray"}
                    >
                        {ele.intents > 0 && <CiCircleCheck />}
                    </Tag>
                );
            }
        },
        {
            // Indica si l'exercici s'ha completat en Mode Desafiament (origen_success)
            key: 'modo_desafio',
            title: 'Mode',
            width: 90,
            align: 'center',
            render: (_, ele) => (
                ele.progres === 1
                    ? <ModoDesafioTag origenSuccess={ele.origen_success} />
                    : null
            )
        },
        {
            key: 'tests',
            title: 'Tests / Intents',
            dataIndex: 'tests',
            width: 110,
            align: 'center',
            render: (e, ele) => {
                const isProf = user.tipus === "0" || user.tipus === "1";
                if (isProf) {
                    return (
                        <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                            <Tooltip title={`Tests de l'exercici: ${e}`}>
                                <Tag color={e === 0 ? "red" : "cyan"} style={{ borderRadius: 6, fontWeight: 600 }}>
                                    {e} tests
                                </Tag>
                            </Tooltip>
                            <Tooltip title={`Enviaments realitzats: ${ele.intents || 0}`}>
                                <Tag color="blue" style={{ borderRadius: 6, fontWeight: 600 }}>
                                    {ele.intents || 0} int.
                                </Tag>
                            </Tooltip>
                        </div>
                    );
                }
                return (
                    <Tooltip title={`Enviaments realitzats: ${ele.intents || 0}`}>
                        <Tag color="blue" style={{ borderRadius: 6, fontWeight: 600 }}>
                            {ele.intents || 0} intents
                        </Tag>
                    </Tooltip>
                );
            }
        },
        {
            key: 'actions',
            title: 'Accions',
            align: 'center',
            width: 350,
            render: (e, ele) => (
                <Space wrap>
                    {/* Badge for used Candado */}
                    {javamonStatus?.candado?.find((c: any) => c.idProblema === ele.id) && !activitat?.is_concurs && (() => {
                        const jm = javamonStatus.candado.find((c: any) => c.idProblema === ele.id);
                        return (
                            <Tooltip title={`Candado desbloqueado por ${jm.nom}`}>
                                <div style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 5,
                                    background: 'linear-gradient(90deg, #e8fff0, #d4f5e2)',
                                    border: '1px solid #52c41a',
                                    borderRadius: 20, padding: '3px 10px 3px 4px',
                                    fontSize: 11, fontWeight: 700, color: '#237804',
                                    boxShadow: '0 1px 4px rgba(82,196,26,0.18)'
                                }}>
                                    <div style={{
                                        width: 26, height: 26, borderRadius: '50%',
                                        background: 'radial-gradient(circle, #f6ffed, #e8fff0)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        flexShrink: 0, border: '1px solid #b7eb8f'
                                    }}>
                                        <img src={getJavamonImage(jm)} style={{ width: 20, height: 20, objectFit: 'contain' }} alt={jm.nom} />
                                    </div>
                                    🔓 {jm.nom}
                                </div>
                            </Tooltip>
                        );
                    })()}


                    {(() => {
                        if (!canShowAccessButton(ele)) return null;

                        const hasNormalAttempt = ele.first_origen === 0 || (ele.first_origen === null && (ele.intents > 0 || ele.progres > 0) && ele.origen_success === 0);
                        if (modoDesafio && hasNormalAttempt) {
                            return null;
                        }

                        return (
                            <Tooltip title={modoDesafio ? "Iniciar desafío" : "Accedir"}>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    icon={modoDesafio ? <span style={{ fontSize: "16px" }}>⚔️</span> : <BiArrowFromLeft />}
                                    onClick={() => modoDesafio ? startDesafioModal(ele) : navigate(`/jutge/activitats/${id_activitat}/problemes/${ele.id}`)}
                                    style={{ backgroundColor: modoDesafio ? "darkred" : JutgeColors.colors.color4 }}
                                />
                            </Tooltip>
                        );
                    })()}
                    {estaBloqueadoPorDependencia(ele) && (() => {
                        const esJoc = esDependenciaDeJuego(ele);
                        const ids = idsDependencia(ele);
                        // Solo los prerequisitos que aún no están completados
                        const pendientes = ids.filter((depId: string) => {
                            const dep = dades?.find((e: any) => (e.id + "") === depId);
                            return !dep || dep.progres < 1;
                        });
                        // Mensaje de prerequisitos pendientes (si los hay)
                        const txtPendientes = pendientes.length > 0
                            ? `Debes completar primero: ${pendientes.map((depId: string) => {
                                const dep = dades?.find((e: any) => (e.id + "") === depId);
                                return dep ? `${depId} (${dep.prac})` : depId;
                            }).join(", ")}`
                            : "";
                        // El tooltip combina ambas condiciones si el ejercicio es de juego Y tiene pendientes.
                        const tooltip = esJoc
                            ? ("Disponible exclusivamente desde el juego" + (txtPendientes ? ". " + txtPendientes : ""))
                            : txtPendientes;
                        // La etiqueta prioriza mostrar el candado de prerequisitos; si no hay, muestra "Solo Juego".
                        const etiqueta = pendientes.length > 0
                            ? (pendientes.length > 1 ? `🔒 ${pendientes.length} pendientes` : `🔒 ${pendientes.join(",")}`)
                            : "🎮 Solo Juego";
                        return (
                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                <Tooltip title={tooltip}>
                                    <Tag
                                        color={pendientes.length > 0 ? "red" : "purple"}
                                        style={{
                                            fontSize: '0.75rem',
                                            borderRadius: '8px',
                                            padding: '4px 8px',
                                            fontWeight: 'bold',
                                            cursor: 'not-allowed'
                                        }}
                                    >
                                        {etiqueta}
                                    </Tag>
                                </Tooltip>
                                {hasCandado && !javamonStatus?.candado?.some((c: any) => c.idProblema === ele.id) && (
                                    <Tooltip title="Usar Javamon Candado para desbloquear">
                                        <Button
                                            shape="circle"
                                            size="small"
                                            icon={<FaUnlock />}
                                            onClick={() => openSelectionModal('CANDADO', ele)}
                                            style={{ backgroundColor: 'green', border: 'none', color: '#fff' }}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                        );
                    })()}
                    {(user.tipus === "2") && !activitat?.is_concurs && (
                        <>
                            {(javamonStatus?.test?.some((c: any) => c.idProblema === ele.id)) ? (() => {
                                const jm = javamonStatus.test.find((c: any) => c.idProblema === ele.id);
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                        <Tooltip title={`Tests visibles gracias a ${jm.nom}`}>
                                            <div style={{
                                                display: 'inline-flex', alignItems: 'center', gap: 5,
                                                background: 'linear-gradient(90deg, #e6f4ff, #d6eaff)',
                                                border: '1px solid #1890ff',
                                                borderRadius: 20, padding: '3px 10px 3px 4px',
                                                fontSize: 11, fontWeight: 700, color: '#0050b3',
                                                boxShadow: '0 1px 4px rgba(24,144,255,0.18)'
                                            }}>
                                                <div style={{
                                                    width: 26, height: 26, borderRadius: '50%',
                                                    background: 'radial-gradient(circle, #e6f7ff, #bae0ff)',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    flexShrink: 0, border: '1px solid #91caff'
                                                }}>
                                                    <img src={getJavamonImage(jm)} style={{ width: 20, height: 20, objectFit: 'contain' }} alt={jm.nom} />
                                                </div>
                                                🔬 {jm.nom}
                                            </div>
                                        </Tooltip>
                                        <Tooltip title="Ver Tests (Desbloqueado)">
                                            <Button
                                                shape="circle"
                                                icon={<FaListAlt />}
                                                onClick={() => nouTestModal(ele, true)}
                                                style={{ backgroundColor: '#1890ff', border: 'none', color: '#fff' }}
                                            />
                                        </Tooltip>
                                    </div>
                                );
                            })() : (
                                (hasTest && !javamonStatus?.test?.some((c: any) => c.idProblema === ele.id) && !estaBloqueadoPorDependencia(ele) && potAccedir(ele)) && (
                                    <Tooltip title="Usar Javamon para ver Tests">
                                        <Button
                                            shape="circle"
                                            icon={<FaListAlt />}
                                            onClick={() => openSelectionModal('TEST', ele)}
                                            style={{ backgroundColor: 'gray', border: 'none', color: '#fff' }}
                                        />
                                    </Tooltip>
                                )
                            )}
                        </>
                    )}
                    {ele.progres === 1 && activitat.estat !== 1 && (
                        <Tooltip title="Visualitzar">
                            <Button
                                shape="circle"
                                icon={<FaEye />}
                                onClick={() => checkElement(ele)}
                                style={{ backgroundColor: JutgeColors.colors.color3, border: 'none', color: '#fff' }}
                            />
                        </Tooltip>
                    )}
                    {ele.progres < 1 && ele.intents > 0 && activitat.estat !== 1 && (
                        <Tooltip title="Veure intents">
                            <Button
                                shape="circle"
                                icon={<FaEye />}
                                onClick={() => checkElement(ele)}
                                style={{ backgroundColor: JutgeColors.colors.color1, border: 'none', color: '#fff' }}
                            />
                        </Tooltip>
                    )}
                    {activitat.estat === 4 && ele.progres === 0 && ele.reclamar === null && (
                        <Tooltip title="Demanar Revisió">
                            <Button
                                shape="circle"
                                icon={<FaQuestionCircle />}
                                onClick={() => reclamar(ele)}
                                style={{ backgroundColor: JutgeColors.colors.color6, border: 'none', color: '#fff' }}
                            />
                        </Tooltip>
                    )}
                    {/* Botón para ver enunciado si está cerrado o no accesible (y no es borrador), o siempre si estamos en modo visualización del juego */}
                    {(isGameModal || (!canShowAccessButton(ele) && (ele.progres === 1 || activitat.estat !== 1) && (dependenciaCumplida(ele) || activitat.estat !== 3) && (!ele.inici || (ele.now ? new Date(ele.now) : new Date()) >= new Date(ele.inici)))) && (
                        <Tooltip title="Veure Enunciat">
                            <Button
                                shape="circle"
                                icon={<FaBookOpen />}
                                onClick={() => verEnunciado(ele)}
                                style={{ backgroundColor: JutgeColors.colors.color4, border: 'none', color: '#fff' }}
                            />
                        </Tooltip>
                    )}
                    {(user.tipus === "0" || user.tipus === "1") && (
                        <Tooltip title="Veure entregues dels alumnes">
                            <Button
                                shape="circle"
                                icon={<FaUsers />}
                                onClick={() => veureAlumnes(ele)}
                                style={{
                                    backgroundColor: JutgeColors.colors.color2,
                                    border: 'none',
                                    color: '#fff'
                                }}
                            />
                        </Tooltip>
                    )}
                    {((user.tipus === "0" || user.tipus === "1") || window.location.hostname.includes("localhost")) && (
                        <Dropdown
                            menu={{
                                items: [
                                    ...((user.tipus === "0" || user.tipus === "1") ? [
                                        {
                                            key: 'configuracio',
                                            label: 'Configuració',
                                            icon: <VscSettingsGear style={{ color: JutgeColors.colors.color5 }} />,
                                            onClick: () => editar(ele)
                                        },
                                        {
                                            key: 'nou-test',
                                            label: 'Tests',
                                            icon: <SlMagnifier style={{ color: JutgeColors.colors.color3 }} />,
                                            onClick: () => nouTestModal(ele)
                                        },
                                        {
                                            key: 'premis',
                                            label: 'Premis',
                                            icon: <TrophyOutlined style={{ color: JutgeColors.colors.color4 }} />,
                                            onClick: () => rankings(ele)
                                        }
                                    ] : []),
                                    {
                                        key: 'test-javamon',
                                        label: 'Recompensa Javamon (Test)',
                                        icon: <MdCatchingPokemon style={{ color: '#ff4d4f', fontSize: 16 }} />,
                                        onClick: () => handleTestJavamonReward(ele)
                                    }
                                ]
                            }}
                            trigger={['click']}
                        >
                            <Button shape="circle" icon={<MoreOutlined />} />
                        </Dropdown>
                    )}
                    {ele.has_rewards === 1 && ele.reward_obtained === 0 && ele.progres === 1 && (String(ele.origen_success) === "1" && !esDependenciaDeJuego(ele)) && (
                        <Tooltip title="Reclamar Recompensa">
                            <Button
                                shape="circle"
                                icon={<GiftOutlined />}
                                onClick={() => handleClaimRewardClick(ele)}
                                style={{ backgroundColor: 'gold', border: 'none', color: '#000' }}
                            />
                        </Tooltip>
                    )}
                    {ele.has_rewards === 1 && ele.reward_obtained === 0 && ele.progres === 1 && (String(ele.origen_success) === "2" || esDependenciaDeJuego(ele)) && (
                        <Tooltip title="Recompensa disponible en el juego (Unity)">
                            <Button
                                disabled
                                shape="circle"
                                icon={<GiftOutlined />}
                                style={{ backgroundColor: '#f0f0f0', border: 'none', color: '#aaa', cursor: 'not-allowed' }}
                            />
                        </Tooltip>
                    )}
                    {/* [LOCALHOST] Forzar obtención de recompensa ignorando requisitos (solo pruebas) */}
                    {IS_LOCALHOST && ele.has_rewards === 1 && ele.reward_obtained === 0 && (
                        <Tooltip title="[LOCALHOST] Forzar recompensa (ignora requisitos)">
                            <Button
                                shape="circle"
                                icon={<ThunderboltOutlined />}
                                onClick={() => handleForceClaimRewardClick(ele)}
                                style={{ backgroundColor: '#ff7875', border: 'none', color: '#fff' }}
                            />
                        </Tooltip>
                    )}
                    {/* Botón de Dependencia para Admins */}
                    {(user.tipus === "0" || user.tipus === "1") && (() => {
                        const esJoc = esDependenciaDeJuego(ele);
                        const ids = idsDependencia(ele);
                        const tieneDeps = ids.length > 0;
                        // Tooltip combinando ambas condiciones (juego y/o lista de prerequisitos).
                        let tooltip: string;
                        if (!esJoc && !tieneDeps) {
                            tooltip = "Sin dependencia";
                        } else {
                            const partes: string[] = [];
                            if (esJoc) partes.push("Juego/Desafío");
                            if (tieneDeps) partes.push(`Depende de: ${ids.join(", ")}`);
                            tooltip = partes.join(" · ");
                        }
                        // Icono simple y legible (el detalle completo va en el tooltip):
                        //  - con prerequisitos -> candado + nº (ej: 🔒2); el color morado indica si ademas es de juego
                        //  - solo juego -> 🎮
                        //  - sin dependencia -> candado abierto
                        const icon = tieneDeps
                            ? <span style={{ fontWeight: 'bold', fontSize: '0.7rem' }}>🔒{ids.length}</span>
                            : esJoc
                                ? <span style={{ fontSize: '0.9rem' }}>🎮</span>
                                : <UnlockOutlined />;
                        return (
                            <Tooltip title={tooltip}>
                                <Button
                                    shape="circle"
                                    icon={icon}
                                    onClick={() => gestionDependencia(ele)}
                                    style={{
                                        // morado si interviene el juego (solo o combinado), coral si solo prerequisitos
                                        backgroundColor: esJoc ? '#722ed1' : (tieneDeps ? 'lightcoral' : JutgeColors.colors.color2),
                                        border: 'none',
                                        color: '#fff',
                                        minWidth: '32px'
                                    }}
                                />
                            </Tooltip>
                        );
                    })()}

                    {
                        activitat.estat === 4 && ele.progres !== 0 && (
                            <Button
                                disabled
                                shape="circle"
                                icon={<FaCheck />}
                                style={{ backgroundColor: JutgeColors.colors.color5, color: '#fff' }}
                            />
                        )
                    }
                    {
                        activitat.estat === 4 && ele.progres === 0 && ele.intents > 0 && (
                            <Button
                                disabled
                                shape="circle"
                                icon={<ImCross />}
                                style={{ backgroundColor: JutgeColors.colors.color6, color: '#fff' }}
                            />
                        )
                    }
                    {
                        activitat.estat === 4 && ele.intents === 0 && (
                            <Tag color={JutgeColors.colors.color6}>No Presentat</Tag>
                        )
                    }
                    {modalExamen && (
                        <ExamenModal
                            element={selected}
                            visible={modalExamen}
                            onClose={() => setModalExamen(false)}
                        />
                    )}

                </Space >
            )
        }
    ];

    // Función para comprobar si se puede acceder
    function potAccedir(ele: any) {
        const avui = new Date(ele.now);
        const inici = ele.inici ? new Date(ele.inici) : null;
        const final = ele.final ? new Date(ele.final) : null;

        // Usuarios admin o profesor
        if (["0", "1"].includes(user.tipus)) return true;

        // Si no hay fechas, también se permite
        if (!inici && !final) return true;

        // Si solo hay inicio
        if (inici && !final) return avui >= inici;

        // Si solo hay final
        if (!inici && final) return avui <= final;

        // Si hay ambas fechas
        if (inici && final) return avui >= inici && avui <= final;

        return false;
    }

    const deterministicRandom = (seedStr: string) => {
        let hash = 0;
        for (let i = 0; i < seedStr.length; i++) {
            hash = ((hash << 5) - hash) + seedStr.charCodeAt(i);
            hash |= 0;
        }
        const x = Math.sin(hash++) * 10000;
        return x - Math.floor(x);
    };

    const handleClaimRewardClick = async (ele: any) => {
        if (ele.origen_success === 2) {
            message.warning("Esta recompensa solo se puede reclamar desde el juego (Unity).");
            return;
        }
        const id_problema = ele.id + "";
        try {
            message.loading({ content: "Revisando recompensas...", key: "claim" });
            const recompensas = await GetProblemaRecompenses(id_problema, id_activitat + "");

            // Recompensas base del problema sin javamons para modo desafío
            const baseNonJavamonRewards = (recompensas || []).filter((r: any) => !r.tipo || !r.tipo.startsWith('JAVAMON'));

            // Comprobar si hay recompensas con grupo_seleccion > 0 (elección entre varias)
            const groupedRewards = (recompensas || []).filter((r: any) => Number(r.grupo_seleccion) > 0);
            if (groupedRewards.length > 0) {
                message.destroy("claim");
                setSelectionOptions(groupedRewards);
                setPendingSelectionItem(ele);
                setSelectableMode(true);
                setRecompensaModalVisible(true);
                return;
            }

            // Comprobar probabilidad de aparición de Javamon según la actividad
            // Si no estamos en Modo Desafío o es concurso, nunca aparece javamon al reclamar en web
            let triggerBattle = false;
            let isActivityJavamon = false;

            if (modoDesafio && !activitat?.is_concurs) {
                const prob = Number(activitat?.javamons ?? 0);
                if (prob > 0) {
                    const roll = Math.random() * 100;
                    if (roll < prob) {
                        triggerBattle = true;
                        isActivityJavamon = true;
                    }
                }
            }

            if (triggerBattle) {
                const data = await GetJavamonConfig();
                if (data) {
                    const rarities = data.rarities && data.rarities !== "null" ? JSON.parse(data.rarities) : [];
                    const allJavamons = data.javamons && data.javamons !== "null" ? JSON.parse(data.javamons) : [];

                    // Filtrar javamons por la temporada configurada en la actividad ("Temporada Javamon")
                    const seasonId = activitat?.id_season;
                    let candidateJavamons = allJavamons.filter((jm: any) =>
                        jm.active && (!seasonId || String(jm.id_season) === String(seasonId))
                    );

                    // Si no hay javamons en la temporada seleccionada, usar todos los activos como fallback
                    if (candidateJavamons.length === 0) {
                        candidateJavamons = allJavamons.filter((jm: any) => jm.active);
                    }

                    const activeRarities = rarities.filter((r: any) => r.active);

                    if (activeRarities.length > 0 && candidateJavamons.length > 0) {
                        // 1. Roll rareza según chance configurada en BD
                        const totalRarityChance = activeRarities.reduce((sum: number, r: any) => sum + (Number(r.chance) || 0), 0);
                        const rndRarity = Math.random() * (totalRarityChance > 0 ? totalRarityChance : 100);
                        let rarityChosen = activeRarities[0];
                        let accumR = 0;
                        for (let c of activeRarities) {
                            accumR += (Number(c.chance) || 0);
                            if (rndRarity <= accumR) {
                                rarityChosen = c;
                                break;
                            }
                        }

                        // 2. Filtrar javamons de la rareza elegida dentro de la temporada
                        let availableOfRarity = candidateJavamons.filter((jm: any) => jm.id_rarity === rarityChosen.id);
                        if (availableOfRarity.length === 0) {
                            availableOfRarity = candidateJavamons;
                        }

                        // 3. Roll javamon dentro de los candidatos según chance configurada
                        const totalJmChance = availableOfRarity.reduce((sum: number, j: any) => sum + (Number(j.chance) || 0), 0);
                        const rndJavamon = Math.random() * (totalJmChance > 0 ? totalJmChance : 100);
                        let jmChosen = availableOfRarity[0];
                        let accumJ = 0;
                        for (let j of availableOfRarity) {
                            accumJ += (Number(j.chance) || 0);
                            if (rndJavamon <= accumJ) {
                                jmChosen = j;
                                break;
                            }
                        }

                        if (jmChosen) {
                            // Registrar reclamo pasando el previewJavamonId
                            const claimRes = await PostClaimReward(id_activitat + "", id_problema, user.id + "", undefined, jmChosen.id + "");
                            if (!claimRes || claimRes.status !== 'ok') {
                                message.error({ content: claimRes?.message || "Error al reclamar la recompensa", key: "claim" });
                                return;
                            }

                            message.destroy("claim");
                            checkDades();

                            // Lista de recompensas a mostrar en el modal resumen
                            const previewRewards = [
                                ...baseNonJavamonRewards,
                                { tipo: 'JAVAMON', data: jmChosen }
                            ];

                            setPendingJavamonBattle({
                                idProblema: id_problema,
                                javamon: {
                                    id: jmChosen.id,
                                    name: jmChosen.nom,
                                    image: getJavamonImage(jmChosen),
                                    rarity: rarityChosen?.nom || 'normal'
                                }
                            });

                            setSelectableMode(false);
                            setRecompensaItems(previewRewards);
                            setRecompensaModalVisible(true);
                            return;
                        }
                    }
                }
            }

            // Si no apareció Javamon, reclamar recompensas normales
            const res = await PostClaimReward(id_activitat + "", id_problema, user.id + "");
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "Recompensa reclamada con éxito", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                setRecompensaModalVisible(true);
                checkDades();
            } else {
                message.error({ content: res?.message || "Error al reclamar la recompensa", key: "claim" });
            }
        } catch (e: any) {
            console.error("Error al reclamar recompensa:", e);
            message.error({ content: e?.message || "Error de red", key: "claim" });
        }
    };

    // [LOCALHOST] Fuerza la obtención de recompensa ignorando requisitos (origen, intentos,
    // tiempo, nota mínima). Reutiliza el flujo de selección de grupo si procede. No dispara
    // la batalla/captura de Javamon (se otorga directamente lo que corresponda vía backend).
    const handleForceClaimRewardClick = async (ele: any) => {
        const id_problema = ele.id + "";
        try {
            message.loading({ content: "[LOCALHOST] Forzando recompensa...", key: "claim" });
            const recompensas = await GetProblemaRecompenses(id_problema, id_activitat + "");

            // Si hay recompensas con grupo de selección, abrir el modal de elección (usa force vía handleConfirmSelection).
            const groupedRewards = (recompensas || []).filter((r: any) => Number(r.grupo_seleccion) > 0);
            if (groupedRewards.length > 0) {
                message.destroy("claim");
                setSelectionOptions(groupedRewards);
                setPendingSelectionItem({ ...ele, __force: true });
                setSelectableMode(true);
                setRecompensaModalVisible(true);
                return;
            }

            const res = await PostClaimReward(id_activitat + "", id_problema, user.id + "", undefined, undefined, false, null, undefined, true);
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "[LOCALHOST] Recompensa forzada con éxito", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                setRecompensaModalVisible(true);
                checkDades();
            } else {
                message.error({ content: res?.message || "Error al forzar la recompensa", key: "claim" });
            }
        } catch (e: any) {
            console.error("Error al forzar recompensa:", e);
            message.error({ content: e?.message || "Error de red", key: "claim" });
        }
    };

    const handleConfirmSelection = async (chosenReward: any) => {
        if (!pendingSelectionItem) return;
        const id_problema = pendingSelectionItem.id + "";
        try {
            message.loading({ content: "Reclamando tu selección...", key: "claim" });
            const forceSelection = !!(pendingSelectionItem as any)?.__force;
            const res = await PostClaimReward(id_activitat + "", id_problema, user.id + "", undefined, undefined, false, chosenReward.id, undefined, forceSelection);
            if (res && res.status === 'ok') {
                message.success({ content: res.message || "¡Recompensa elegida y obtenida con éxito!", key: "claim" });
                setSelectableMode(false);
                setRecompensaItems(res.claimed || []);
                checkDades();
            } else {
                message.error({ content: res?.message || "Error al reclamar la recompensa seleccionada", key: "claim" });
            }
        } catch (e: any) {
            message.error({ content: e?.message || "Error al reclamar", key: "claim" });
        }
    };

    const onBattleSuccess = async () => {
        if (activeRewardData && battleJavamon) {
            if (activeRewardData.isTest) {
                const ok = await AssignJavamonToUser(activeRewardData.userId, battleJavamon.id);
                if (ok) {
                    message.success(`¡Has capturado a ${battleJavamon.name}! Guardado en tu inventario.`);
                    checkDades();
                } else {
                    message.error("Error al asignar el Javamon capturado al inventario.");
                }
                return;
            }

            const res = await PostClaimReward(activeRewardData.idActivitat, activeRewardData.idProblema, activeRewardData.userId, battleJavamon.id + "");
            if (res && res.status === 'ok') {
                message.success(res.message);
                checkDades();
            } else {
                message.error("Error al reclamar la recompensa tras captura");
            }
        }
    };

    const handleTestJavamonReward = async (ele: any) => {
        try {
            message.loading({ content: "Generando recompensa de prueba (Javamon aleatorio)...", key: "test-javamon" });
            const data = await GetJavamonConfig();
            if (!data) {
                message.error({ content: "No se pudo cargar la configuración de Javamons", key: "test-javamon" });
                return;
            }

            const rarities = data.rarities && data.rarities !== "null" ? JSON.parse(data.rarities) : [];
            const allJavamons = data.javamons && data.javamons !== "null" ? JSON.parse(data.javamons) : [];

            const seasonId = activitat?.id_season;
            let candidateJavamons = allJavamons.filter((jm: any) =>
                jm.active && (!seasonId || String(jm.id_season) === String(seasonId))
            );

            if (candidateJavamons.length === 0) {
                candidateJavamons = allJavamons.filter((jm: any) => jm.active);
            }

            if (candidateJavamons.length === 0) {
                message.error({ content: "No hay Javamons activos configurados", key: "test-javamon" });
                return;
            }

            const activeRarities = rarities.filter((r: any) => r.active);
            const totalRarityChance = activeRarities.reduce((sum: number, r: any) => sum + (Number(r.chance) || 0), 0);
            const rndRarity = Math.random() * (totalRarityChance > 0 ? totalRarityChance : 100);
            let rarityChosen = activeRarities[0];
            let accumR = 0;
            for (let c of activeRarities) {
                accumR += (Number(c.chance) || 0);
                if (rndRarity <= accumR) {
                    rarityChosen = c;
                    break;
                }
            }

            let availableOfRarity = candidateJavamons.filter((jm: any) => jm.id_rarity === rarityChosen?.id);
            if (availableOfRarity.length === 0) {
                availableOfRarity = candidateJavamons;
            }

            const totalJmChance = availableOfRarity.reduce((sum: number, j: any) => sum + (Number(j.chance) || 0), 0);
            const rndJavamon = Math.random() * (totalJmChance > 0 ? totalJmChance : 100);
            let jmChosen = availableOfRarity[0];
            let accumJ = 0;
            for (let j of availableOfRarity) {
                accumJ += (Number(j.chance) || 0);
                if (rndJavamon <= accumJ) {
                    jmChosen = j;
                    break;
                }
            }

            if (jmChosen) {
                const id_problema = ele.id + "";
                message.destroy("test-javamon");

                setPendingJavamonBattle({
                    idProblema: id_problema,
                    isTest: true,
                    javamon: {
                        id: jmChosen.id,
                        name: jmChosen.nom,
                        image: getJavamonImage(jmChosen),
                        rarity: rarityChosen?.nom || 'normal'
                    }
                });

                setSelectableMode(false);
                setRecompensaItems([
                    { tipo: 'JAVAMON', data: jmChosen }
                ]);
                setRecompensaModalVisible(true);
            }
        } catch (err: any) {
            console.error("Error al testear Javamon aleatorio:", err);
            message.error({ content: err?.message || "Error al testear Javamon", key: "test-javamon" });
        }
    };


    const stats = useMemo(() => {
        if (!Array.isArray(dades) || dades.length === 0) {
            return { total: 0, completed: 0, attempts: 0, totalPunts: 0, avgProgress: 0 };
        }
        let completed = 0;
        let attempts = 0;
        let totalPunts = 0;
        let sumProgress = 0;

        // Filtrar ejercicios según rol y contexto:
        // Los alumnos web comunes (no admin/profe y fuera de isGameModal)
        // solo deben ver ejercicios con Dependencia de Juego si ya los han resuelto (progres >= 1).
        const visibleDades = dades.filter((ex: any) => {
            const isGameDep = esDependenciaDeJuego(ex);
            if (!isGameDep) return true;
            if (["0", "1"].includes(user.tipus)) return true;
            if (isGameModal) return true;
            return (Number(ex.progres) || 0) >= 1;
        });

        visibleDades.forEach((ex: any) => {
            const prog = Number(ex.progres) || 0;
            if (prog >= 1) completed++;
            attempts += (Number(ex.intents) || 0);
            totalPunts += (Number(ex.puntuacion) || 0);
            sumProgress += (prog * 100);
        });

        return {
            total: visibleDades.length,
            completed,
            attempts,
            totalPunts,
            avgProgress: visibleDades.length > 0 ? Math.round(sumProgress / visibleDades.length) : 0
        };
    }, [dades, user.tipus, isGameModal]);

    const filteredDades = useMemo(() => {
        if (!Array.isArray(dades)) return [];
        // Filtrar ejercicios de juego para que el alumnado solo los vea desde el juego (o profesorado/admin),
        // o en la web si ya han sido resueltos por el alumno.
        const baseList = dades.filter((ex: any) => {
            const isGameDep = esDependenciaDeJuego(ex);
            if (!isGameDep) return true;
            if (["0", "1"].includes(user.tipus)) return true;
            if (isGameModal) return true;
            return (Number(ex.progres) || 0) >= 1;
        });

        const sorted = [...baseList].sort((a: any, b: any) => a.id - b.id);
        if (!searchText.trim()) return sorted;
        const q = searchText.toLowerCase();
        return sorted.filter((ex: any) =>
            (ex.prac && ex.prac.toLowerCase().includes(q)) ||
            (ex.enunciat && ex.enunciat.toLowerCase().includes(q)) ||
            (ex.tags && ex.tags.toLowerCase().includes(q)) ||
            String(ex.id).includes(q)
        );
    }, [dades, searchText, user.tipus, isGameModal]);

    const gameExercisesCount = useMemo(() => {
        if (!Array.isArray(dades)) return 0;
        return dades.filter((ex: any) => {
            if (!esDependenciaDeJuego(ex)) return false;
            // Para alumnos en la web, solo contamos los que aún no están resueltos (los resueltos ya se muestran en la tabla)
            if (!["0", "1"].includes(user.tipus) && !isGameModal) {
                return (Number(ex.progres) || 0) < 1;
            }
            return true;
        }).length;
    }, [dades, user.tipus, isGameModal]);

    const tableProps: TableProps<any> = {
        loading,
        pagination: false
    };

    return (
        <div style={{ padding: '0 0 24px 0' }}>
            {/* Capçalera amb títol, cercador, mode desafiament i refrescar */}
            <div style={{
                marginBottom: 20,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 16,
                flexWrap: 'wrap'
            }}>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Title level={3} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                            <CodeOutlined style={{ color: '#1890ff' }} /> Llista d'Exercicis
                        </Title>
                        {Array.isArray(dades) && (
                            <Badge
                                count={stats.total}
                                style={{ backgroundColor: '#1890ff', fontWeight: 600 }}
                                overflowCount={999}
                            />
                        )}
                    </div>
                    <Typography.Text type="secondary" style={{ fontSize: 13 }}>
                        {activitat?.nom ? `${activitat.nom} · ` : ''}Exercicis i reptes disponibles per a aquesta activitat
                    </Typography.Text>
                </div>

                <Space wrap size="middle">
                    <Input
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        placeholder="Cercar per nom, tag o ID..."
                        allowClear
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 240, borderRadius: 8 }}
                    />

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        background: (isGameModal || modoDesafio) ? 'linear-gradient(90deg, #fff1f0, #ffe8e6)' : '#f5f5f5',
                        padding: '4px 12px',
                        borderRadius: 20,
                        border: (isGameModal || modoDesafio) ? '1px solid #ffa39e' : '1px solid #e8e8e8'
                    }}>
                        <span style={{
                            fontWeight: 600,
                            fontSize: 13,
                            color: (isGameModal || modoDesafio) ? '#cf1322' : '#595959',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4
                        }}>
                            {(isGameModal || modoDesafio) ? '⚔️' : '🛡️'} Mode Desafiament
                        </span>
                        {!isGameModal && (
                            <Switch size="small" checked={modoDesafio} onChange={handleToggleModoDesafio} />
                        )}
                    </div>

                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        onClick={() => checkDades()}
                        loading={loading}
                        style={{ borderRadius: 8 }}
                    >
                        Refrescar
                    </Button>
                </Space>
            </div>

            {/* Targetes de resum KPI (Estil unificat amb Estadístiques i Alumnes) */}
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Exercicis Totals</span>}
                            value={stats.total}
                            prefix={<CodeOutlined style={{ color: '#1890ff', marginRight: 6 }} />}
                            valueStyle={{ fontWeight: 700, fontSize: 26 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Exercicis Superats</span>}
                            value={stats.completed}
                            suffix={<span style={{ fontSize: 14, color: '#8c8c8c' }}>/ {stats.total}</span>}
                            prefix={<CheckCircleOutlined style={{ color: '#52c41a', marginRight: 6 }} />}
                            valueStyle={{ color: '#52c41a', fontWeight: 700, fontSize: 26 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Progrés Mitjà</span>}
                            value={stats.avgProgress}
                            suffix="%"
                            prefix={<AreaChartOutlined style={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', marginRight: 6 }} />}
                            valueStyle={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', fontWeight: 700, fontSize: 26 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Intents Totals</span>}
                            value={stats.attempts}
                            prefix={<FireOutlined style={{ color: '#fa8c16', marginRight: 6 }} />}
                            valueStyle={{ color: '#fa8c16', fontWeight: 700, fontSize: 26 }}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Taula principal amb estil Premium */}
            <Card
                bordered={false}
                bodyStyle={{ padding: 0 }}
                style={{
                    borderRadius: 14,
                    overflow: 'hidden',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
                    background: '#fff',
                }}
            >
                <Table
                    {...tableProps}
                    key={refreshKey}
                    columns={
                        // Desde el juego (iframe de Unity), el alumnado NO ve la columna
                        // "Accions" (es solo visualización). Profesorado/admin (tipus 0/1)
                        // sí la ven siempre.
                        (isGameModal && !["0", "1"].includes(user.tipus))
                            ? columns.filter((c: any) => c.key !== 'actions')
                            : columns
                    }
                    size="middle"
                    showHeader={true}
                    dataSource={filteredDades}
                    rowKey="id"
                    pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ['15', '30', '50', '100'],
                        defaultPageSize: 15,
                        style: { padding: '12px 24px', margin: 0 }
                    }}
                />
            </Card>

            {/* Aviso informativo de ejercicios opcionales del modo juego */}
            {!isGameModal && gameExercisesCount > 0 && (
                <div style={{ marginTop: 14, display: 'flex', justifyContent: 'flex-start' }}>
                    <Tag
                        color="warning"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '6px 14px',
                            borderRadius: 8,
                            fontSize: 13,
                            border: '1px solid #ffe58f',
                            backgroundColor: '#fffbe6',
                            color: '#d46b08'
                        }}
                    >
                        <span style={{ fontSize: 16 }}>🎮</span>
                        <span>
                            <strong>Modo Juego:</strong> Hay {gameExercisesCount === 1 ? '1 ejercicio opcional' : `${gameExercisesCount} ejercicios opcionales`} adicionales que solo están disponibles dentro del juego.
                        </span>
                    </Tag>
                </div>
            )}

            {!loading && !isGameModal && (
                <FloatButton.Group
                    trigger="click"
                    type="primary"
                    style={{ insetInlineStart: 97 }}
                    icon={<IoOptions />}
                >
                    {["0", "1"].includes(user.tipus) && (
                        <>
                            <FloatButton
                                shape="circle"
                                onClick={() => setImportExcelVisible(true)}
                                style={{ backgroundColor: '#237804' }}
                                icon={<FileExcelOutlined style={{ color: 'black' }} />}
                                tooltip="Importar Excel"
                            />
                            <FloatButton
                                shape="circle"
                                onClick={() => nuevo()}
                                style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                icon={<BiPlus />}
                            />
                        </>
                    )}
                    <FloatButton
                        shape="circle"
                        onClick={() => checkDades()}
                        style={{ backgroundColor: JutgeColors.colors.color6 }}
                        icon={<BiRefresh />}
                    />
                </FloatButton.Group>
            )}

            {importExcelVisible && (
                <ImportarExerciciExcelModal
                    visible={importExcelVisible}
                    id_activitat={id_activitat + ""}
                    onClose={() => setImportExcelVisible(false)}
                    onSuccess={() => checkDades()}
                />
            )}

            {modal && (
                <RevisioModal
                    element={selected}
                    visible={modal}
                    onClose={closeModal}
                />
            )}
            {modalNuevo && (
                <NouModal
                    element={selected}
                    visible={modalNuevo}
                    id_activitat={id_activitat + ""}
                    onClose={closeNouModal}
                />
            )}
            {modalTestNuevo && (
                <TestsListModal
                    id_problema={selected.id}
                    id_activitat={id_activitat + ""}
                    visible={modalTestNuevo}
                    onClose={closeNouTestModal}
                    nom={selected.prac}
                    isMulti={selected.multi === 1}
                    readOnly={testsReadOnly}
                />
            )}
            {rankingsVisible && (<PremiosModal
                idProblema={selected.id}
                idActivitat={id_activitat + ""}
                visible={rankingsVisible}
                onClose={(refresh: boolean) => closeModalRanking(refresh)}
            />
            )}
            {modalDependencia && (
                <DependenciaModal
                    visible={modalDependencia}
                    onClose={closeModalDependencia}
                    id_activitat={id_activitat + ""}
                    targetProblem={selected}
                    allProblems={dades}
                />
            )}
            {modalEnunciat && (
                <EnunciatModal
                    element={selected}
                    id_activitat={id_activitat + ""}
                    visible={modalEnunciat}
                    onClose={() => setModalEnunciat(false)}
                />
            )}

            {modalAlumnes && (
                <Modal
                    title={`Entregues dels alumnes${selected?.prac ? ` · ${selected.prac}` : ''}`}
                    open={modalAlumnes}
                    onCancel={() => setModalAlumnes(false)}
                    footer={null}
                    width={1200}
                    destroyOnClose
                >
                    <ProblemaIdAlumnes
                        propIdProblema={selected?.id + ""}
                        propIdActivitat={id_activitat + ""}
                        isModal={true}
                    />
                </Modal>
            )}

            {claimedJavamon && (
                <JavaMon
                    onClose={() => setClaimedJavamon(null)}
                    userId={user.id + ""}
                    forcedJavamon={claimedJavamon}
                />
            )}

            {incenseTimeLeft && (
                <div style={{ position: 'fixed', top: 80, right: 20, zIndex: 1000 }}>
                    <Alert
                        message="Incienso Activo"
                        description={`Tiempo restante: ${incenseTimeLeft}`}
                        type="info"
                        showIcon
                        icon={<MdCatchingPokemon />}
                        style={{ border: '1px solid #1890ff', backgroundColor: '#e6f7ff' }}
                    />
                </div>
            )}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontSize: 22 }}>{selectionModal.type === 'CANDADO' ? '🔓' : '🔬'}</span>
                        <div>
                            <div style={{ fontWeight: 800, fontSize: 16, color: '#1f1f1f' }}>
                                {selectionModal.type === 'CANDADO' ? 'Desbloquear ejercicio' : 'Ver Tests del ejercicio'}
                            </div>
                            <div style={{ fontWeight: 400, fontSize: 12, color: '#888' }}>
                                Selecciona el JAVAmon a gastar
                            </div>
                        </div>
                    </div>
                }
                open={selectionModal.visible}
                onCancel={() => setSelectionModal({ ...selectionModal, visible: false })}
                footer={null}
                width={520}
                styles={{ body: { padding: '24px 20px' } }}
            >
                {availableJavamons.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '32px 0', color: '#aaa' }}>
                        <div style={{ fontSize: 40, marginBottom: 8 }}>🌫️</div>
                        <div style={{ fontSize: 15, fontWeight: 600 }}>No tienes JAVAmons disponibles</div>
                        <div style={{ fontSize: 12, marginTop: 4 }}>Consíguelos completando ejercicios del ranking</div>
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
                        gap: 14,
                    }}>
                        {availableJavamons.map((j: any) => (
                            <div
                                key={j.id}
                                onClick={() => handleUseJavamon(j)}
                                style={{
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    borderRadius: 14,
                                    padding: '14px 8px 10px',
                                    background: 'linear-gradient(145deg, #ffffff, #f5f7fb)',
                                    border: '1.5px solid #e8eaf0',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    transition: 'all 0.2s ease',
                                    position: 'relative',
                                    overflow: 'hidden',
                                }}
                                onMouseEnter={e => {
                                    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 6px 20px rgba(99,102,241,0.22)';
                                    (e.currentTarget as HTMLDivElement).style.border = '1.5px solid #818cf8';
                                    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-3px)';
                                }}
                                onMouseLeave={e => {
                                    (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                                    (e.currentTarget as HTMLDivElement).style.border = '1.5px solid #e8eaf0';
                                    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                                }}
                            >
                                <div style={{
                                    width: 80, height: 80, margin: '0 auto 10px',
                                    background: 'radial-gradient(circle at 40% 40%, #eef2ff, #faf5ff)',
                                    borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    boxShadow: 'inset 0 1px 4px rgba(0,0,0,0.05)'
                                }}>
                                    <img src={getJavamonImage(j)} style={{ width: 64, height: 64, objectFit: 'contain' }} alt={j.nom} />
                                </div>
                                <div style={{ fontWeight: 700, fontSize: 13, color: '#1e1e2e', lineHeight: 1.3 }}>{j.nom}</div>
                                {j.rarity && (
                                    <div style={{
                                        marginTop: 5,
                                        display: 'inline-block',
                                        fontSize: 10,
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.5,
                                        padding: '2px 8px',
                                        borderRadius: 20,
                                        background: j.rarity?.toLowerCase().includes('epic') ? '#f0e6ff' :
                                            j.rarity?.toLowerCase().includes('legend') ? '#fff7e6' : '#f0f5ff',
                                        color: j.rarity?.toLowerCase().includes('epic') ? '#7c3aed' :
                                            j.rarity?.toLowerCase().includes('legend') ? '#d97706' : '#4f46e5',
                                    }}>{j.rarity}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </Modal>

            {/* Start Desafio Modal */}
            <Modal
                open={ideStartModalVisible}
                maskClosable={false}
                closable={false}
                footer={null}
                centered
                title={"Iniciar Desafío"}
            >
                <div style={{ textAlign: 'center', minHeight: 180, padding: '20px 0' }}>
                    {ideStartLoading ? (
                        <>
                            <div style={{ border: '5px solid #f3f3f3', borderTop: '5px solid #3498db', borderRadius: '50%', width: 40, height: 40, animation: 'spin 1s linear infinite', margin: '20px auto' }}></div>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            <h3 style={{ marginTop: 20 }}>Preparando entorno...</h3>
                            <p>Esperando a que el contenedor Docker arranque. Esto puede tardar 1-2 minutos.</p>
                            <Button
                                danger
                                style={{ marginTop: 20 }}
                                onClick={() => setIdeStartModalVisible(false)}
                            >
                                Cancelar
                            </Button>
                        </>
                    ) : ideStartError ? (
                        <>
                            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
                            <h3 style={{ color: '#cf1322' }}>Error al preparar el entorno</h3>
                            <p style={{ color: '#666', marginBottom: 20 }}>{ideStartError}</p>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    onClick={() => ideStartExamEl && startExamProcess(ideStartExamEl)}
                                    style={{ background: '#722ed1', borderColor: '#722ed1' }}
                                >
                                    🔄 Reintentar
                                </Button>
                                <Button
                                    size="large"
                                    danger
                                    onClick={() => setIdeStartModalVisible(false)}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <DesktopOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                            <h3>Entorno Listo</h3>
                            <p>Tu entorno de desarrollo está preparado para el desafío.</p>
                            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center', gap: 10 }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    icon={<ExportOutlined />}
                                    disabled={!ideStartUrl}
                                    onClick={async () => {
                                        setIdeStartModalVisible(false);
                                        try {
                                            await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost'}:8061/jutge/enviament/init`, {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                                                },
                                                body: JSON.stringify({
                                                    id_problema: ideStartExamEl.id + "",
                                                    id_activitat: id_activitat + "",
                                                    id_usuari: userId + "",
                                                    origen: "WEB_DESAFIO"
                                                })
                                            });
                                        } catch (e) { }
                                        checkDades();
                                        window.open(ideStartUrl, '_blank');
                                    }}
                                    style={{ background: '#722ed1', borderColor: '#722ed1' }}
                                >
                                    Entrar
                                </Button>
                                <Button
                                    size="large"
                                    danger
                                    onClick={() => setIdeStartModalVisible(false)}
                                >
                                    Salir
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {recompensaModalVisible && (
                <RecompensaSummaryModal
                    visible={recompensaModalVisible}
                    onClose={() => {
                        setRecompensaModalVisible(false);
                        if (pendingJavamonBattle) {
                            setActiveRewardData({ idActivitat: id_activitat + "", idProblema: pendingJavamonBattle.idProblema, userId: user.id + "", isTest: pendingJavamonBattle.isTest });
                            setBattleJavamon(pendingJavamonBattle.javamon);
                            setShowBattle(true);
                            setPendingJavamonBattle(null);
                        }
                    }}
                    rewards={recompensaItems}
                    selectableMode={selectableMode}
                    selectionOptions={selectionOptions}
                    onConfirmSelection={handleConfirmSelection}
                    currentAttempts={pendingSelectionItem?.intents ?? pendingSelectionItem?.enviament_count ?? 0}
                    currentNota={pendingSelectionItem?.nota ?? 100}
                    currentTimeSeconds={pendingSelectionItem?.tiempo_empleado_segundos}
                />
            )}
            {showBattle && (
                <JavaMon
                    userId={user.id + ""}
                    onClose={() => {
                        setShowBattle(false);
                    }}
                    onSuccess={() => {
                        onBattleSuccess();
                    }}
                    forcedJavamon={battleJavamon}
                />
            )}
        </div>
    );
};

export default ActivitatsIdExercicis;
